<template>
  <div>
    <div class="content"></div>
    <div
      class="cover mobile"
      :class="{ active: active }"
      :style="{
        background: `url(${cover.mobileCoverImage})`,
        backgroundPositionX: 0,
        backgroundPositionY: 0,
      }"
    >
      <div class="cover__main-image">
        <img :src="cover.mainImage.src" alt="CoverMainImage" />
      </div>
      <div class="cover__caption primary-text-color">
        {{ $t(cover.caption) }}
      </div>
      <div class="cover__arrow">
        <img src="../../../assets/icons/arrowdown.png" alt="arrow-down" />
      </div>
    </div>
    <div
      :class="{ active: active }"
      class="cover pc"
      :style="{
        background: `url(${cover.backgroundImage})`,
      }"
    >
      <div class="cover__main-image">
        <!-- <overdrive id="test2" :easing="easing" :duration="600">
        </overdrive>-->
        <img
          :src="cover.mainImage.pcSrc"
          alt="CoverMainImage"
          ref="coverMainImage"
        />
        <!-- <overdrive id="test">
        </overdrive>-->
        <!-- :srcset="`${cover.mainImage.pcSrc} 1024w, ${cover.mainImage.src} 360w`" -->
      </div>
      <div class="cover__caption primary-text-color">
        {{ $t(cover.caption) }}
      </div>
      <div class="cover__arrow">
        <img src="../../../assets/icons/arrowdown.png" alt />
      </div>
    </div>
    <BoxList :box="box" :categoryKey="categoryKey"></BoxList>
    <BoxList
      v-if="dezeenBox"
      :box="dezeenBox"
      :categoryKey="categoryKey"
      class="margin-mobile"
    ></BoxList>
    <BoxList
      v-if="worldcup"
      :box="worldcup"
      :categoryKey="categoryKey"
      class="margin-mobile"
    ></BoxList>
     <BoxList
      v-if="disney"
      :box="disney"
      :categoryKey="categoryKey"
      class="margin-mobile"
    ></BoxList>
    <!-- <div class="mobile"></div>
    <div class="pc"></div>-->
  </div>
</template>

<script>
import CategoryOverdrive from "@/models/overdrive/Landing_Category";
import { OverdriveKey as BoxOverdrive } from "@/models/overdrive/Category_Box";
import { CategoryLists } from "@/models/CategoryKey";
import OnLoadImage from "@/components/mixin/OnLoadImage";
import BoxList from "./BoxList";
import objectFitImages from "object-fit-images";

import * as easing from "eases/quint-out";
export default {
  mixins: [OnLoadImage],
  props: {
    categoryKey: {
      type: String,
      default: () => CategoryLists.Lifestyle.list.Serif,
    },
    cover: {
      type: Object,
      default: () => ({}),
    },
    box: {
      type: Object,
      default: () => ({}),
    },
    dezeenBox: {
      type: Object,
      default: () => null, //if has empty object throw error
    },
    worldcup:{
      type:Object,
      default: () => null,
    },
     disney:{
      type:Object,
      default: () => null,
    },
  },
  watch: {
    "$route.params"() {
      window.scrollTo(0, 0);
      location.reload();
    },
  },
  data() {
    return {
      easing,
      // filterList: ["ALL", 43, 49, 55],
      selectedFilter: "ALL",
      CategoryOverdrive,
      BoxOverdrive,
      ref: undefined,
      active: false,
    };
  },
  async mounted() {
    await this.$nextTick(() => {
      return objectFitImages(this.$refs.coverMainImage);
    });
    this.active = true;
    window.sessionStorage.setItem("introFlag", false)
  },
  components: {
    BoxList,
  },
};
</script>

<style scoped>
.mobile {
  display: flex;
}
.margin-mobile {
  padding-bottom: 0px;
}
.pc {
  display: none !important;
}
.content {
  height: 54px;
  position: relative;
}
.cover {
  position: relative;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: 50% 50% !important;
  /* padding-top: 54px; */

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: auto;
  object-fit: fill;
  object-position: center;
  height: 118.9vw;
  opacity: 0;
  transition: opacity 0.5s;
}
.cover.active {
  opacity: 1;
}
.cover > * {
  z-index: 1;
}
.cover::after {
  content: " ";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 0;
  top: 0;
  left: 0;
}
.cover .cover__main-image {
  margin-top: auto;
}
.cover .cover__main-image img {
  /* position: relative;
  top: 50%;
  transform: translateY(-50%); */
  /* height: 100vh; */
  max-width: 58.8vw;
  max-height:60vw;
  /* max-height: ; */
}
.cover .cover__caption {
  margin-top: auto;
  font-size: 1.84rem;
  font-weight: 700;
}
.cover .cover__arrow img {
  width: 30px;
  margin-top: 6.94vw;
  margin-bottom: 5.55vw;
}

@media (max-width: 1023px) {
  .margin-mobile {
    padding-top: 100px;
    /* padding-bottom: 100px; */
  }
  .clock {
    width: 10px;
  }
}

@media (min-width: 1024px) {
  .clock {
    width: auto;
  }
  .content {
    margin-top: 0;
    height: 0;
  }
  .mobile {
    display: none !important;
  }
  .pc {
    display: flex !important;
  }
  .cover {
    background-size: cover !important;
    /* background-position: top; */
    height: 900px;
  }
  .cover::after {
    height: 900px;
  }
  .cover .cover__main-image {
    margin-top: 201px;
  }
  .cover .cover__main-image img {
    width: 474px;
    /* height: 509px; */
    max-height: 450px;
    object-fit: contain;
    font-family: "object-fit: contain;";

    /* margin-top: 0; */
    /* width: 500px; */
  }
  .cover .cover__caption {
    width: auto;
    font-size: 3.29rem;
    margin-top: auto;
    /* margin-top: 0; */
    /* width: 500px; */
    font-weight: 700;
  }

  .cover .cover__arrow img {
    margin-top: 60px;
    margin-bottom: 21px;
    width: 60px;
    /* font-size: 3.29rem;
    margin-top: 31px; */
    /* margin-top: 0; */
    /* width: 500px; */
  }
}
@media (max-width: 1200px) {
  .box-list__items ul {
    justify-content: center;
  }
}

.background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  left: 0;
  top: 0;
  border-radius: 25px;
  z-index: -1;
}
</style>
